import { ControlFacet } from '../models/controls/ControlFacet';
import { IStyleFunction } from 'office-ui-fabric-react/lib/Utilities';
import { IEmptyFolderStyleProps, IEmptyFolderStyles } from '../components/itemsEmptyFolder/EmptyFolder.styles';

/**
 * @public
 */
export interface IEmptyFolderControlProps {
    itemKey: string;
}

/**
 * @public
 */
export interface IEmptyFolderOverrides {
    emptyFolderIconUrl: string;
    emptyFolderTitle: string;
    getStyles: IStyleFunction<IEmptyFolderStyleProps, IEmptyFolderStyles>;
}

/**
 * @public
 */
export const emptyFolderControl: ControlFacet<IEmptyFolderControlProps, IEmptyFolderOverrides> = new ControlFacet('emptyFolderControl');
